<template>
  <a :href="`http://line.me/R/msg/text?${text}`">
    <img src="~@/assets/icon/line-button.svg" alt="LINEで送る" />
  </a>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: location.href
    }
  }
}
</script>
